import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

// SERVICES
import { CuentasService } from 'src/app/services/cuentas_maestras.service';

@Component({
  selector: 'app-crear-cuentas',
  templateUrl: './crear-cuentas.component.html',
  styleUrls: ['./crear-cuentas.component.scss'],
})
export class CrearCuentasComponent implements OnInit {
  form = this.fb.group({
    titular: [
      '',
      [
        Validators.required,
        Validators.maxLength(50),
      ],
    ],
    tipo_documento: ['', [Validators.required, Validators.maxLength(1)]],
    numero_documento_cuenta: [
      '',
      [
        Validators.required,
        Validators.maxLength(10),
        Validators.minLength(7),
        Validators.pattern('^[0-9]*$'),
      ],
    ],
    numero_cuenta: [
      '',
      [
        Validators.maxLength(20),
        Validators.minLength(20),
        Validators.pattern('^[0-9]*$'),
      ],
    ],
    pago_movil: [
      '',
      [
        Validators.maxLength(11),
        Validators.minLength(11),
        Validators.pattern('^[0-9]*$'),
      ],
    ],
    tipo_cuenta: ['Corriente'],
    borrado: [0],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });

  tiposDocumentos: any = [
    { name: 'V' },
    { name: 'J' },
    { name: 'E' },
    { name: 'G' },
    { name: 'C' },
  ];

  constructor(
    public dialogRef: MatDialogRef<CrearCuentasComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar: MatSnackBar,
    private cuentasService: CuentasService
  ) {}

  ngOnInit(): void {}

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  onSubmit() {
    //console.log(this.form.value);
    this.cuentasService.crear(this.form.value).subscribe((data) => {
      //console.log(data);
      this.openSnackBar('Tipo Operación creado con éxito', 'X');
      this.dialogRef.close();
    });
  }
}
